export const APP = 'APP';
export const PUBLIC = 'PUBLIC';